import React, { useEffect, useState } from "react";

import AddCategory from "./components/AddCategory";
import CategoryList from "./components/CategoryList";
import CategoryDetail from "./components/CategoryDetail";
import Axios from "services/api/config";
import { getMasterCategories, updateMasterCategory } from "services/api/routes/Admin";
import { message } from "antd";

const Category: React.FC = () => {
	const [state, setState] = useState({
		loading: false,
		masterCategories: [],
	});
	const [category, setCategory] = useState();

	const fetchMasterCategories = async () => {
		try {
			setState((prev) => ({ ...prev, loading: true }));
			const { data: masterRes } = await Axios({ ...getMasterCategories() });
			// const { data: categoryRes } = await Axios({ ...getCategories() });
			// console.log("categoryRes"?, categoryRes?);
			if (masterRes.data && masterRes?.data?.masterCategories) {
				setState((prev) => ({
					...prev,
					masterCategories: masterRes?.data?.masterCategories || [],
				}));
			}
		} catch (error) {
			console.error(error);
		} finally {
			setState((prev) => ({ ...prev, loading: false }));
		}
	};

	const toggleStatus = async (row) => {
		try {
			const newStatus = row.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
			const formData = new FormData();
			formData.append("status", newStatus);
			await Axios({
				...updateMasterCategory(row.id),
				data: formData,
				headers: { "Content-Type": "multipart/form-data" },
			});
			fetchMasterCategories();
		} catch (error) {
			message.error("Failed to update status");
			console.error(error);
		}
	};

	useEffect(() => {
		fetchMasterCategories();
	}, []);

	if (category) {
		return <CategoryDetail {...{ 
			category, 
			setCategory: (data) => {
				!data && fetchMasterCategories()
				setCategory(data)
		} }} />;
	}

	return (
		<div className="space-y-2">
			<AddCategory onCreated={fetchMasterCategories} />
			<CategoryList
				masterCategories={state.masterCategories}
				setCategory={setCategory}
				toggleStatus={toggleStatus}
			/>
		</div>
	);
};

export default Category;
